const review_document = {
	name: 'Document Review | Document Reviews',
	fields: {
		hp_id: 'ID',
		name: 'Description',
		team: {
			last_name: 'Contact Person',
		},
		status: 'Status',
		active: 'Active',
		completed: 'Completed',
		building_id: 'Building ID',
		building_name: '@:entity.building.name',
		accounting_year: {
			year: '@:component.accounts.accountingYear',
		},
	},
}

export default review_document
